import { useQuery } from '@tanstack/react-query';
import { EGeozoneQueryKey, useGeozoneStore } from 'entities/geozone';
import { useCustomerId } from 'entities/user';

export const useGeozones = () => {
  const fetchGeozones = useGeozoneStore(state => state.fetchGeozones);
  const geozones = useGeozoneStore(state => state.list);
  const customerId = useCustomerId()

  const geozonesQuery = useQuery({
    queryKey: [
      EGeozoneQueryKey.GEOZONES,
    ],
    queryFn: () => fetchGeozones(customerId),
  });

  return {
    geozones,
    geozonesQuery,
  };
};
